/* Shared lifecycle for the theme's existing Owl components. */
(() => {
  if (window.nomosuLegacyInteractions || !window.jQuery) return;
  window.nomosuLegacyInteractions = true;
  const $ = window.jQuery;
  const observers = new Map();
  const profiles = [
    ['.product-carousel', {loop:true,margin:10,nav:true,dots:false,responsive:{0:{items:1},600:{items:2},1000:{items:3}}}],
    ['.testimonial-carousel', {loop:true,margin:60,nav:false,dots:false,responsive:{0:{items:1},600:{items:2},1000:{items:3}}}],
    ['.home-collection-carousel', {loop:true,margin:10,nav:true,dots:false,responsive:{0:{items:2},600:{items:2},1200:{items:3}}}],
    ['.product-gallery.owl-carousel', {loop:true,margin:0,nav:true,dots:false,responsive:{0:{items:1},600:{items:1},1000:{items:1}}}],
    ['.comp-carousel', {loop:true,margin:10,nav:true,dots:true,responsive:{0:{items:1},600:{items:2},1000:{items:3}}}],
    ['.drawer-carousel', {items:1,loop:true,margin:10,nav:true,dots:true}],
    ['.ingredients-carousel', {items:1,loop:true,margin:10,nav:true,dots:false}],
    ['.related-products-carousel', {items:1,loop:true,margin:10,nav:true,dots:false}],
  ];
  const find = (root, selector) => [
    ...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector),
  ];
  function cleanClones(element) {
    element.querySelectorAll('.owl-item.cloned').forEach((clone) => {
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id],[data-shopify-editor-block]').forEach((node) => {
        node.removeAttribute('id'); node.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((node) => node.setAttribute('tabindex', '-1'));
    });
  }
  function initialize(root = document) {
    if (!$.fn.owlCarousel) return;
    profiles.forEach(([selector, settings]) => find(root, selector).forEach((element) => {
      if (selector === '.ingredients-carousel' && innerWidth >= 768) return;
      if (element.classList.contains('owl-loaded') || !element.children.length) return;
      $(element).on('initialized.owl.carousel.nomosu refreshed.owl.carousel.nomosu', () => cleanClones(element));
      $(element).owlCarousel({...settings, loop:settings.loop && !window.Shopify?.designMode});
    }));
    find(root, 'product-recommendations').forEach((element) => {
      if (observers.has(element)) return;
      const observer = new MutationObserver(() => initialize(element));
      observer.observe(element, {childList:true,subtree:true}); observers.set(element, observer);
    });
    alignNutrition();
  }
  function dispose(root) {
    find(root, '.owl-loaded').forEach((element) => {
      if (element.closest('nomosu-customer-testimonials')) return;
      $(element).trigger('destroy.owl.carousel').off('.nomosu');
    });
    observers.forEach((observer, element) => {
      if (element === root || root.contains(element) || !element.isConnected) {
        observer.disconnect(); observers.delete(element);
      }
    });
  }
  function alignNutrition() {
    const reference = document.querySelector('.customer-testimonial .page-width');
    if (!reference) return;
    const padding = getComputedStyle(reference).paddingLeft;
    document.querySelectorAll('.nutrition-facts .nf-body').forEach((body) => { body.style.paddingLeft = padding; });
  }
  $(document).on('change.nomosuLegacy', '.variant-select', function () {
    const price = this.options[this.selectedIndex]?.getAttribute('data-price');
    const card = this.closest('.product-card,.item');
    if (!card || price == null) return;
    card.querySelectorAll('.variant-price,.var-coll-price').forEach((element) => { element.textContent = price; });
  });
  $(document).on('click.nomosuLegacy', '.card-coll-title', function () {
    $(this).closest('.collection-list__item').find('.ingredient-list').toggleClass('active');
  });
  $(document).on('click.nomosuLegacy', '.nf-dropdown', function () {
    $(this).find('ul').toggleClass('open'); $(this).toggleClass('active');
  });
  $(document).on('click.nomosuLegacy', '.accordion-titel', function () {
    const item = $(this).closest('.accordion-item');
    item.find('.accordion-contant').stop(true,true).slideToggle(); item.toggleClass('active');
    item.siblings('.accordion-item').removeClass('active').find('.accordion-contant').stop(true,true).slideUp();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => dispose(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const element = event.target.closest?.('.owl-item');
    const carousel = element?.closest('.owl-loaded');
    if (!carousel || carousel.closest('nomosu-customer-testimonials')) return;
    const index = [...element.parentElement.children].filter((item) => !item.classList.contains('cloned')).indexOf(element);
    if (index >= 0) $(carousel).trigger('stop.owl.autoplay').trigger('to.owl.carousel', [index,0,true]);
  });
  window.addEventListener('resize', () => {
    document.querySelectorAll('.ingredients-carousel.owl-loaded').forEach((element) => {
      if (innerWidth >= 768) $(element).trigger('destroy.owl.carousel').off('.nomosu');
    });
    initialize();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
})();
